(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySettingInfoController', CompanySettingInfoController);

    CompanySettingInfoController.$inject = ['$rootScope', '$scope', '$state', 'SettingInfo', 'SettingInfoCustom', 'ParseLinks', 'AlertService', 'CompanyCustom', '$stateParams'];

    function CompanySettingInfoController($rootScope, $scope, $state, SettingInfo, SettingInfoCustom, ParseLinks, AlertService, CompanyCustom, $stateParams) {
        var vm = this;
        //
        vm.loadPage = loadPage;
        vm.save = save;
        vm.settingInfo = {};
        vm.isInMarketPlace = false;
        vm.settingFormSection = $stateParams.settingFormSection;
        vm.goToWebSite = goToWebSite;
        vm.saveComplete = false;

        vm.okModal = okModal;
        vm.closeModal = closeModal;
        vm.getModalTitle = getModalTitle;

        loadPage();

        //function loadAll () {
        //
        //    function onSuccess(data, headers) {
        //        vm.settingInfos = data;
        //    }
        //    function onError(error) {
        //        AlertService.error(error.data.message);
        //    }
        //}

        function save() {
            vm.isSaving = true;
            if (vm.settingInfo.id !== null) {
                SettingInfo.update(vm.settingInfo, onSaveSuccess, onSaveError);
            } else {
                SettingInfoCustom.saveWithCompany().save(vm.settingInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:settingInfoUpdate', result);
            //$uibModalInstance.close(result);
            vm.isSaving = false;
            vm.saveComplete = true;

            // if($state.current.parent == 'supplierPanel-v2.dashboard')
            //     $state.go('supplierPanel-v2.dashboard');

        }

        function onSaveError() {
            vm.isSaving = false;
        }


        function loadPage() {
            //
            $rootScope.$broadcast('hideNavBar');
            vm.settingInfo = SettingInfoCustom.getSettingInfoByCurrentCompany().query();

            //is company in marketPlace

            CompanyCustom.isCurrentCompanyListedInAnyMarketPlaces().query().$promise.then(function (result) {

                if (result.status == 'DONE')
                    vm.isInMarketPlace = true;
                else
                    vm.isInMarketPlace = false;
            });
        }


        function goToWebSite() {
            CompanyCustom.getCompanyWebSiteAddressClearCache(function (site) {
                if (site)
                    window.open(site, '_blank');
            });

        }

        function okModal() {
            save();

        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');

            if ($state.current.parent == 'supplierPanel-v2.dashboard')
                $state.go('supplierPanel-v2.dashboard');
            else
                $state.go('supplierPanel-v2.setting');

        }

        function getModalTitle() {

            if ($stateParams.settingFormSection) {
                switch ($stateParams.settingFormSection) {
                    case 'themeSettingTab' :
                        return 'tikonApp.settingInfo.sections.themeSettingTab-v2';
                    case 'notificationSettingTab' :
                        return 'tikonApp.settingInfo.sections.notificationSettingTab';
                    case 'financialSettingTab' :
                        return 'tikonApp.settingInfo.sections.financialSettingTab';
                    case 'videoCallSettingTab' :
                        return 'tikonApp.settingInfo.sections.videoCallSettingTab';
                }
            } else
                return 'supplierPanel.sideMenu.companyInfo.setting';
        }
    }
})();
